import React, { memo } from 'react';
import PropTypes from 'prop-types';

import cn from 'utils/classnames';

import styles from './PlacePublishStatusBadge.module.scss';

function PlacePublishStatusBadge({ isPublished, className }) {
  return (
    <span
      className={cn(styles.Component, className)}
      data-published={isPublished ? 'true' : 'false'}
    >
      {isPublished
        ? 'Mở/ Có thể đặt phòng'
        : 'Ẩn/ Không thể đặt phòng'}
    </span>
  );
}

PlacePublishStatusBadge.propTypes = {
  isPublished: PropTypes.bool,
  className: PropTypes.string,
};

PlacePublishStatusBadge.defaultProps = {
  isPublished: false,
  className: '',
};

export default memo(PlacePublishStatusBadge);
